import React, { ChangeEvent, HTMLAttributes, useRef } from 'react';
import cl from 'classnames';
import styles from './checkboxStyle.module.scss';

type CheckboxProps = {
  label?: string;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  checked: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  changed?: boolean;
};

export const Checkbox = ({
  label,
  disabled,
  className,
  labelClassName,
  checked,
  onChange,
  changed = false,
  ...otherProps
}: CheckboxProps & HTMLAttributes<HTMLInputElement>) => {
  const checkboxRef = useRef<HTMLInputElement | null>(null);

  return (
    <div
      className={cl(styles.container, disabled && styles.disabled, className)}
    >
      <input
        ref={checkboxRef}
        type="checkbox"
        checked={checked || false}
        onChange={onChange}
        className={styles.checkbox}
        disabled={disabled}
        tabIndex={-1}
        {...otherProps}
      />
      <div
        onClick={(event) => {
          event.preventDefault();
          checkboxRef.current?.click();
        }}
        className={styles.label}
      >
        <div
          className={cl(
            styles.icon,
            checked && styles.checked,
            changed && styles.changed,
          )}
        >
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.0001 11.2799L3.2201 8.4999L2.27344 9.43989L6.0001 13.1666L14.0001 5.16656L13.0601 4.22656L6.0001 11.2799Z"
              fill="white"
            />
          </svg>
        </div>
        {label && (
          <div className={cl(styles.title, labelClassName)}>{label}</div>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
